var React = require('react');

function Flower (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M435.86,256C462.7,232.54,480,198.45,480,160A128,128,0,0,0,352,32c-38.45,0-72.54,17.3-96,44.14C232.54,49.3,198.45,32,160,32A128,128,0,0,0,32,160c0,38.45,17.3,72.54,44.14,96C49.3,279.46,32,313.55,32,352A128,128,0,0,0,160,480c38.45,0,72.54-17.3,96-44.14C279.46,462.7,313.55,480,352,480A128,128,0,0,0,480,352C480,313.55,462.7,279.46,435.86,256ZM335.2,335.2A112,112,0,1,1,368,256,112,112,0,0,1,335.2,335.2Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M336,256a80,80,0,1,1-80-80A80,80,0,0,1,336,256Z","className":"fa-primary","key":2})]);
}

Flower.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Flower;

Flower.default = Flower;
